module.exports = __webpack_public_path__ + "static/media/logoblue.f93591e7.png";